var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaGoalSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53125 7.15625L8 5.40625L10.4375 7.15625L9.5 10H6.46875L5.53125 7.15625ZM7.96875 0C12.4062 0 15.9688 3.65625 15.9688 8.03125C15.9688 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 7.96875 0ZM13.5938 11.3125C14.0625 10.5 14.3438 9.625 14.4375 8.65625L11.7812 6.78125L12.8438 3.71875C12.2188 3 11.4688 2.4375 10.5938 2.0625L8 4L5.375 2.0625C4.53125 2.4375 3.75 3 3.125 3.71875L4.1875 6.78125L1.53125 8.65625C1.625 9.625 1.90625 10.5 2.375 11.3125L5.625 11.25L6.59375 14.375C7.03125 14.4688 7.5 14.5 8 14.5C8.46875 14.5 8.9375 14.4688 9.375 14.375L10.3438 11.25L13.5938 11.3125Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaGoalSmall);
export default __webpack_public_path__ + "static/media/faGoalSmall.9979a05dd454ffb18a4a989107f62159.svg";
export { ForwardRef as ReactComponent };